import { MODULOS } from './perfiles.js'
export const MODULOS_COLORES = {
  [MODULOS.ARMERIA]: {
    primary: '#f4f2ff',
    secondary: '#2F1BA8',
    accent: '#F58634',
    anchor: '#2F1BA8',
  },
  [MODULOS.EQUIPAMIENTO]: {
    primary: '#FFF8F2',
    secondary: '#A85113',
    accent: '#F58634',
    anchor: '#A85113',
  },
  [MODULOS.PROFESIONALIZACION]: {
    primary: '#f2fff8',
    secondary: '#34A871',
    accent: '#F58634',
    anchor: '#34A871',
  },
  [MODULOS.DESARROLLO_POLICIAL]: {
    primary: '#fffbf2',
    secondary: '#BD7E00',
    accent: '#F58634',
    anchor: '#BD7E00',
  },
  [MODULOS.ENLACE_C3]: {
    primary: '#fffbf2',
    secondary: '#F5B840',
    accent: '#F7C465',
    anchor: '#D69D22',
  },
  [MODULOS.RECURSOS_HUMANOS]: {
    primary: '#fff4f2',
    secondary: '#F54127',
    accent: '#F58634',
    anchor: '#F54127',
  },
  [MODULOS.REGISTRO_PERSONAL]: {
    primary: '#fff3f2',
    secondary: '#871913',
    accent: '#F58634',
    anchor: '#871913',
  },
  [MODULOS.CONSULTA_PERSONAL]: {
    primary: '#f5fff2',
    secondary: '#218713',
    accent: '#34f537',
    anchor: '#1a8713',
  },
  [MODULOS.ENLACE]: {
    primary: '#f2fdff',
    secondary: '#138087',
    accent: '#34e6f5',
    anchor: '#138785',
  },
}
